import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/schedule_limit_times`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

const destroy = (fieldId, param) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/schedule_limit_times/destroy_list`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/schedule_limit_times/list`),
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/schedule_limit_times/${id}`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
    isQuiet: param.isQuiet || false,
  });
};

export const ScheduleLimitTimeService = {
  create,
  destroy,
  list,
  update,
};
export default ScheduleLimitTimeService;



// WEBPACK FOOTER //
// ./src/services/ScheduleLimitTimes.js